import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createIcon } from "@chakra-ui/react/icon";
export default createIcon({
    displayName: "CircleSolid",
    viewBox: "0 0 24 24",
    path: (_jsxs(_Fragment, { children: [_jsx("rect", { opacity: "0", width: "24", height: "24", fill: "white", fillOpacity: "0" }), _jsx("path", { d: "M12 6.50024C15.3137 6.50024 18 9.18654 18 12.5002C18 15.814 15.3137 18.5002 12 18.5002C8.68629 18.5002 6 15.814 6 12.5002C6 9.18654 8.68629 6.50024 12 6.50024Z", fillRule: "evenodd", clipRule: "evenodd", fill: "currentColor" })] })),
});
